// app/components/Hero.jsx
import React, { useState, useEffect } from 'react';
import Contacto from './Contacto';
import Galeria from './Galeria';
import Bio from './Bio';

const Hero = () => {
  const [filterIndex, setFilterIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [modalContact, setModalContact] = useState(false);
  const [modalGaleria, setModalGaleria] = useState(false);
  const [modalMerch, setModalMerch] = useState(false);
  const [modalBio, setModalBio] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showAnimationRandomly = () => {
      // Genera un intervalo de tiempo aleatorio entre 2 y 6 segundos
      const randomTime = Math.floor(Math.random() * 40000) + 8000;
      setTimeout(() => {
        setVisible(true);
        // Hace que la animación desaparezca después de 3 segundos
        setTimeout(() => {
          setVisible(false);
        }, 8000);
      }, randomTime);
    };

    // Ejecuta la función por primera vez y repite el proceso
    showAnimationRandomly();
    const interval = setInterval(showAnimationRandomly, 8000); // Cada 5s genera otro tiempo aleatorio

    return () => clearInterval(interval);
  }, []);

  const closeAllModals = () => {
    setModalContact(false);
    setModalMerch(false);
    setModalGaleria(false);
    setModalBio(false);
  };
  const filters = [
    "none",
    "grayscale(100%)",
    "none",
    "sepia(100%)",
    "none",
    "saturate(100%)",
    "none",
    "blur(10px)"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFilterIndex((prevIndex) => (prevIndex + 1) % filters.length);
    }, 4000); // Cambia cada 4 segundos

    return () => clearInterval(interval);
  }, []);

  // Captura la posición del mouse en el documento
  useEffect(() => {
    const handleMouseMove = (e) => {
      const { innerWidth, innerHeight } = window;
      // Normalizamos los valores para estar entre -0.5 y 0.5
      const x = (e.clientX / innerWidth) - 0.5;
      const y = (e.clientY / innerHeight) - 0.5;
      setMousePosition({ x, y });
    };

    // Agrega el evento al mover el mouse
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = (event) => {
    const target = event.currentTarget;
    target.classList.add("scale-110");
    setTimeout(() => {
      target.classList.remove("scale-110");
    }, 300); // El rebote dura 300 ms
  };

  return (
    <div className="flex !overflow-hidden flex-col items-center justify-center h-screen w-screen bg-gray-100 relative">
      {/* <img 
        src="/mouse2.png" // Asegúrate de que la imagen esté en esta ruta
        alt="Cambio de color"
        className={`w-24 h-24 psico`}
      /> */}
      {visible && (
        <div className='w-24 h-24 psico'>
        <div class="rocket rotate-90 scale-50">
          <div class="fuselage">
            <div class="nose"></div>
            <div class="head">
              <span class="window"></span>
            </div>
            <div class="neck"></div>
            <div class="body"></div>
            <div class="reactor"></div>
            <div class="fire">
              <div class="spark1"></div>
              <div class="spark2"></div>
              <div class="spark3"></div>
              <div class="spark4"></div>
              <div class="spark5"></div>
              <div class="spark6"></div>
            </div>
          </div>
          <div class="left-fin"></div>
          <div class="left-fin-end"></div>
          <div class="right-fin"></div>
          <div class="right-fin-end"></div>
        </div>
      </div>
      )}
      
      <div
        className="overflow-hidden w-full h-full transition-all duration-1000"
        style={{ filter: filters[filterIndex], transition: 'filter 2s ease' }}
      >
        <img
          src="/hero.png" // Asegúrate de que la imagen esté en esta ruta
          alt="Cambio de color"
          className={`w-full h-full object-cover transition-transform duration-300 ${isHovered ? "scale-110" : "scale-100"}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        />
      </div>
      {/* Imagen de texto que sigue el mouse */}
      <img
        src="/hero2.svg" // Asegúrate de que la imagen esté en esta ruta
        alt="Texto en imagen"
        className="absolute w-full max-w-4xl"
        style={{
          top: '50%',
          left: '50%',
          transform: `translate(-50%, -50%) rotateX(${mousePosition.y * 60}deg) rotateY(${mousePosition.x * 60}deg)`,
          transition: 'transform 0.1s ease-out',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      />
  
      {/* Botones en cada esquina */}
      <button onClick={() => setModalBio(true)}
        className="absolute w-28 rounded-md float hover:scale-105 hover:shadow-md active:scale-95 !shadow-white special-font top-4 left-4 p-2 bg-black text-white shadow">
        Instructivo
      </button>
      <button onClick={() => setModalGaleria(true)}
       className="absolute w-28 rounded-md float hover:scale-105 hover:shadow-md active:scale-95 !shadow-white special-font top-4 right-4 p-2 bg-black text-white shadow">
        Galería
      </button>
      <button onClick={() => setModalMerch(true)}
       className="absolute w-28 rounded-md float hover:scale-105 hover:shadow-md active:scale-95 !shadow-white special-font bottom-4 left-4 p-2 bg-black text-white shadow">
        Merchandising
      </button>
      <button onClick={() => setModalContact(true)}
       className="absolute w-28 rounded-md float hover:scale-105 hover:shadow-md active:scale-95 !shadow-white special-font bottom-4 right-4 p-2 bg-black text-white shadow">
        Contacto
      </button>

      <Contacto isOpen={modalContact} onClose={closeAllModals} />
      <Galeria isOpen={modalGaleria} onClose={closeAllModals} merch={false} title='Galeria' />
      <Galeria isOpen={modalMerch} onClose={closeAllModals} merch={true} title='Merchandising' />
      <Bio isOpen={modalBio} onClose={closeAllModals} />
    </div>

  );
};

export default Hero;
